import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import router from './router'
import App from './App.vue'
import './styles/main.scss'
import { initMicroApps } from './micro-apps'
// QuickTracking 标准版
import { onReady } from '@/utils/quickTracking'

/**
 * 扫码活体入口使用 Hash 链接（手机端更稳）。
 * 本项目是 History 路由，需在启动前把
 *   /#/agreement-liveness?ticketId=xxx
 *   /#/login-realperson?loginTicket=xxx
 * 转成 History 路径。
 */
;(() => {
  const hash = window.location.hash || ''
  if (!hash) return
  const raw = hash.startsWith('#') ? hash.slice(1) : hash
  if (!raw.startsWith('/agreement-liveness') && !raw.startsWith('/login-realperson')) return
  const target = raw.startsWith('/') ? raw : `/${raw}`
  window.history.replaceState(null, document.title, target)
})()

// 创建Vue应用实例
const app = createApp(App)


// 配置Pinia状态管理
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)
app.use(pinia)

// 配置Element Plus
app.use(ElementPlus, {
  locale: zhCn
})

// 配置路由
app.use(router)

// 初始化 QuickTracking
// 监听 SDK 就绪事件
onReady(() => {
  console.log('[QuickTracking] SDK22 已就绪，自动采集已开启')
})

// 全局错误监听
window.addEventListener('error', (event) => {
  console.error('全局错误:', event.error)
})

// 捕获未处理的 Promise rejection
window.addEventListener('unhandledrejection', (event) => {
  console.error('未处理的 Promise rejection:', event.reason)
})

// 挂载应用
app.mount('#app')

// 初始化微前端应用
initMicroApps()
